/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type GetVolunteerShiftScheduleQueryVariables = Types.Exact<{
  event_id: Types.Scalars["Int"];
}>;

export type GetVolunteerShiftScheduleQuery = {
  volunteerShiftSchedule: Array<
    Pick<
      Types.VolunteerShiftScheduleItem,
      | "shift_id"
      | "event_id"
      | "category_name"
      | "description"
      | "registration_open"
      | "organizer_responsible_user_id"
      | "organizer_responsible_name"
      | "preferred_min_signups"
      | "name"
      | "start_time"
      | "end_time"
      | "location"
      | "max_volunteer_count"
    >
  >;
};

export const GetVolunteerShiftScheduleDocument = gql`
  query GetVolunteerShiftSchedule($event_id: Int!) {
    volunteerShiftSchedule(event_id: $event_id) {
      shift_id
      event_id
      category_name
      description
      registration_open
      organizer_responsible_user_id
      organizer_responsible_name
      preferred_min_signups
      name
      start_time
      end_time
      location
      max_volunteer_count
    }
  }
`;

/**
 * __useGetVolunteerShiftScheduleQuery__
 *
 * To run a query within a React component, call `useGetVolunteerShiftScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVolunteerShiftScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVolunteerShiftScheduleQuery({
 *   variables: {
 *      event_id: // value for 'event_id'
 *   },
 * });
 */
export function useGetVolunteerShiftScheduleQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetVolunteerShiftScheduleQuery,
    GetVolunteerShiftScheduleQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetVolunteerShiftScheduleQuery,
    GetVolunteerShiftScheduleQueryVariables
  >(GetVolunteerShiftScheduleDocument, baseOptions);
}
export function useGetVolunteerShiftScheduleLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetVolunteerShiftScheduleQuery,
    GetVolunteerShiftScheduleQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetVolunteerShiftScheduleQuery,
    GetVolunteerShiftScheduleQueryVariables
  >(GetVolunteerShiftScheduleDocument, baseOptions);
}
export type GetVolunteerShiftScheduleQueryHookResult = ReturnType<
  typeof useGetVolunteerShiftScheduleQuery
>;
export type GetVolunteerShiftScheduleLazyQueryHookResult = ReturnType<
  typeof useGetVolunteerShiftScheduleLazyQuery
>;
export type GetVolunteerShiftScheduleQueryResult =
  ApolloReactCommon.QueryResult<
    GetVolunteerShiftScheduleQuery,
    GetVolunteerShiftScheduleQueryVariables
  >;
